/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountGroupAccountGrid extends SiteEntityGrid<AccountGroupAccountRow, any> {
        protected getColumnsKey() { return 'Data.AccountGroupAccount'; }
        protected getDialogType() { return AccountGroupAccountDialog; }
        protected getIdProperty() { return AccountGroupAccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountGroupAccountRow.localTextPrefix; }
        protected getService() { return AccountGroupAccountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}